export default __webpack_public_path__ + "static/media/btn-deco.7e636711.webp";